import { render, staticRenderFns } from "./PageNeutre.vue?vue&type=template&id=5569f758&scoped=true"
import script from "./PageNeutre.vue?vue&type=script&lang=js"
export * from "./PageNeutre.vue?vue&type=script&lang=js"
import style0 from "./PageNeutre.vue?vue&type=style&index=0&id=5569f758&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5569f758",
  null
  
)

export default component.exports